<template>
    <article class="metric" :class="tone">
        <div class="metric-icon" aria-hidden="true">
            <i :class="icon"></i>
        </div>
        <div class="metric-body">
            <Skeletor v-if="loading" :shimmer="true" height="28" width="72px" />
            <p v-else class="metric-value">{{ cantidad }}</p>
            <p class="metric-label">{{ title }}</p>
        </div>
    </article>
</template>

<script>
export default {
    name: "CardComponent",
    props: {
        title: String,
        cantidad: Number,
        loading: Boolean,
        icon: {
            type: String,
            default: "fas fa-chart-bar"
        },
        tone: {
            type: String,
            default: "blue"
        }
    }
};
</script>

<style scoped>
.metric {
    display: flex;
    align-items: center;
    gap: 14px;
    height: 100%;
    padding: 16px;
    border: 1px solid #e6edf5;
    border-radius: 14px;
    background: #fff;
    box-shadow: 0 8px 20px rgba(15, 35, 52, 0.05);
}

.metric-icon {
    width: 46px;
    height: 46px;
    border-radius: 12px;
    display: grid;
    place-items: center;
    flex-shrink: 0;
    font-size: 1rem;
}

.metric-value {
    margin: 0;
    color: #1f2a37;
    font-size: 1.7rem;
    font-weight: 700;
    line-height: 1;
}

.metric-label {
    margin: 4px 0 0;
    color: #6b7c8f;
    font-size: 0.78rem;
    font-weight: 600;
}

.blue .metric-icon {
    background: #e8f4fc;
    color: #0078be;
}

.teal .metric-icon {
    background: #e7f7f4;
    color: #0f8f7a;
}

.amber .metric-icon {
    background: #fff4e5;
    color: #d17a00;
}

.pink .metric-icon {
    background: #fde8f0;
    color: #eb1265;
}
</style>
